import {Component, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {Observable} from 'rxjs';
import {Item} from '../../models/item.inferface';
import {FuseConfigService} from '../../../@fuse/services/config.service';
import {Router} from '@angular/router';
import { UntypedFormControl } from '@angular/forms';
import { MVLocalStorageService } from 'app/services/mv-local-storage.service';
import { LanguageSelectorComponent } from 'app/layout/components/language-selector/language-selector.component';

@Component({
  selector: 'app-tenant-selector-component',
  templateUrl: 'tenant-selector.component.html',
  styles: [
    `
      :host {
          display: grid;
      }
    `
  ]
})

export class TenantSelectorComponent implements OnInit {
  public tenants: Item[];
  tenantSelector: UntypedFormControl;

  constructor(
    private authService: AuthService,
    private fuseConfigService: FuseConfigService,
    private router: Router,
    private languageSelectorComponent: LanguageSelectorComponent
  ) {
    this.tenants = this.authService.getAvailableTenants();
    this.fuseConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        toolbar: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        sidepanel: {
          hidden: true
        }
      }
    };

    this.tenantSelector = new UntypedFormControl('');

  }

  ngOnInit() {
    if (!this.tenants?.length) {
      // this.authService.enforceLogin(null);
      this.router.navigate(['login'])
    }

    this.tenantSelector.valueChanges.subscribe(tenantId => {
      this.select(tenantId);
    });
  }

  select(tenant) {
    this.authService.login(tenant)
      .subscribe(()=>{
          this.languageSelectorComponent.getFullLabels(MVLocalStorageService.getItem('selected_lang') ? JSON.parse(MVLocalStorageService.getItem('selected_lang')).id : 1)
      });
  }
}
